import './style.css'
import { boot } from './app/boot'
import { showError } from './hud/overlays'

boot(showError).catch((err: unknown) => showError(err))
